import { ToolkitPageLayout } from 'toolkit/components/ToolkitPageLayout'
import { Link } from 'react-router-dom'
import { champions_presentations } from 'assets' // champions_presentations is reused, business_plan_checklist_image to be added

// TODO: Verify and update these external links if they change
const businessPlanChecklistDocUrl =
  'https://docs.google.com/document/d/e/2PACX-1vTNMhUcK-FIm3dDMpa5QQOKHU_N6FytQs2hvIKY573OlppLCFohOA2s6vYmgQXSSA/pub?embedded=true'
const infusionCptCodesPdfUrl =
  'https://www.dropbox.com/scl/fi/ry539icm47xuekwhov75j/Infusion-CPT-Codes.pdf?rlkey=r7cliebfvx8plenwww57yq854&dl=0&dl=1'
const billingReimbursementPdfUrl =
  'https://www.dropbox.com/scl/fi/n0vcz0ovvzbuymtt47xca/Billing-and-Reimbursement.pdf?rlkey=0zadiy23c8iur7q3zr0pu54h2&dl=0&dl=1'
const costEffectivenessInfusionClinicsPdfUrl =
  'https://www.dropbox.com/scl/fi/fs379w26bzyrnh9wx3ay4/cost-effectiveness-infusion-clinics.pdf?rlkey=maedd4beylws5ho0h1lk8gk97&st=5ptddxmz&dl=0'
const buildingCentersTeamVideoUrl =
  'https://drive.google.com/file/d/1ORK4g8xSTmuwKmTV8HC7nJCO0ofSAN0R/view'

export const InstitutionBusinessPlanChecklistPage: React.FC = () => {
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Institution', path: '/toolkit/institution' },
    {
      label: 'Resources for Building an IC',
      path: '/toolkit/institution/building-ic-resources'
    },
    {
      label: 'Business Plan & Checklist',
      path: '/toolkit/institution/business-plan-checklist'
    }
  ]

  return (
    <ToolkitPageLayout
      title="Business Plan & Checklist"
      breadcrumbs={breadcrumbs}
    >
      <div className="prose max-w-none mx-auto px-4 py-8">
        <p className="text-lg mb-6">
          Read and review <strong>Business Plan Development Checklist</strong>:
        </p>
        <div className="mb-10 p-2 sm:p-6 bg-white rounded-lg shadow-lg border border-gray-200">
          <div className="aspect-w-4 aspect-h-3 h-[70vh] md:aspect-w-16 md:aspect-h-9">
            <iframe
              src={businessPlanChecklistDocUrl}
              className="w-full h-full border-none rounded-md"
              title="Business Plan Development Checklist"
            ></iframe>
          </div>
          <div className="mt-4 text-center">
            <a
              href={businessPlanChecklistDocUrl.replace('?embedded=true', '')}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#142841] text-white font-medium px-5 py-2.5 rounded-md hover:bg-[#0F1E30] transition-colors duration-300 text-sm"
            >
              Open Checklist in new tab (Google Docs)
            </a>
          </div>
        </div>

        <h3 className="text-xl font-semibold text-[#142841] mb-4 mt-10">
          Downloadable PDF Resources:
        </h3>
        <div className="grid md:grid-cols-1 gap-8 mb-10">
          <div className="p-6 bg-white rounded-lg shadow-lg border border-gray-200">
            <h4 className="font-semibold text-lg text-[#3C2416] mb-2">
              Examples of Infusion Center CPT Codes
            </h4>
            <p className="text-sm text-gray-600 mb-3">
              Review common CPT codes used in infusion centers.
            </p>
            <a
              href={infusionCptCodesPdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download="Infusion-CPT-Codes.pdf"
              className="inline-block bg-[#142841] text-white font-medium px-5 py-2.5 rounded-md hover:bg-[#0F1E30] transition-colors duration-300 text-sm mb-3"
            >
              Download PDF
            </a>
            <object
              data={infusionCptCodesPdfUrl}
              type="application/pdf"
              width="100%"
              height="500px"
              className="rounded shadow border"
            >
              <p className="text-center text-gray-600 p-4">
                Your browser does not support PDFs. Please download the PDF to
                view it:
                <a
                  href={infusionCptCodesPdfUrl}
                  download="Infusion-CPT-Codes.pdf"
                  className="text-[#142841] hover:text-[#A6410A] underline ml-1"
                >
                  Download PDF
                </a>
                .
              </p>
            </object>
          </div>
          <div className="p-6 bg-white rounded-lg shadow-lg border border-gray-200 mt-8 md:mt-0">
            <h4 className="font-semibold text-lg text-[#3C2416] mb-2">
              Billing and Reimbursement
            </h4>
            <p className="text-sm text-gray-600 mb-3">
              Information on billing practices and reimbursement.
            </p>
            <a
              href={billingReimbursementPdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download="Billing-and-Reimbursement.pdf"
              className="inline-block bg-[#142841] text-white font-medium px-5 py-2.5 rounded-md hover:bg-[#0F1E30] transition-colors duration-300 text-sm mb-3"
            >
              Download PDF
            </a>
            <object
              data={billingReimbursementPdfUrl}
              type="application/pdf"
              width="100%"
              height="500px"
              className="rounded shadow border"
            >
              <p className="text-center text-gray-600 p-4">
                Your browser does not support PDFs. Please download the PDF to
                view it:
                <a
                  href={billingReimbursementPdfUrl}
                  download="Billing-and-Reimbursement.pdf"
                  className="text-[#142841] hover:text-[#A6410A] underline ml-1"
                >
                  Download PDF
                </a>
                .
              </p>
            </object>
          </div>
          <div className="p-6 bg-white rounded-lg shadow-lg border border-gray-200 mt-8 md:mt-0">
            <h4 className="font-semibold text-lg text-[#3C2416] mb-2">
              An impact evaluation of two modes of care for sickle cell disease
              crises
            </h4>
            <p className="text-sm text-gray-600 mb-3">
              Robert Skinner, Andrew Breck & Dominick Esposito
            </p>
            <a
              href={costEffectivenessInfusionClinicsPdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download="cost-effectiveness-infusion-clinics.pdf"
              className="inline-block bg-[#142841] text-white font-medium px-5 py-2.5 rounded-md hover:bg-[#0F1E30] transition-colors duration-300 text-sm mb-3"
            >
              Download PDF
            </a>
            <object
              data={costEffectivenessInfusionClinicsPdfUrl}
              type="application/pdf"
              width="100%"
              height="500px"
              className="rounded shadow border"
            >
              <p className="text-center text-gray-600 p-4">
                Your browser does not support PDFs. Please download the PDF to
                view it:
                <a
                  href={costEffectivenessInfusionClinicsPdfUrl}
                  download="cost-effectiveness-infusion-clinics.pdf"
                  className="text-[#142841] hover:text-[#A6410A] underline ml-1"
                >
                  Download PDF
                </a>
                .
              </p>
            </object>
          </div>
        </div>

        <p className="text-lg mb-6 mt-10">
          Review video below, &quot;Building Center&apos;s Team&quot;:
        </p>
        <figure className="mb-12 text-center">
          <a
            href={buildingCentersTeamVideoUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-gray-300 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
          >
            <img
              src={champions_presentations} // Reusing placeholder, consider specific if available
              alt="Building Center's Team video thumbnail - Nicklaine Paul, RN, BSN, CCM"
              className="max-w-full h-auto rounded-t-lg md:max-w-xl"
            />
            <figcaption className="py-3 px-4 bg-gray-50 rounded-b-lg text-sm text-gray-700">
              Building Center&apos;s Team by Nicklaine Paul, RN, BSN, CCM (Opens
              new tab)
            </figcaption>
          </a>
        </figure>

        <div className="mt-16 text-center">
          <Link
            to="/toolkit/institution/building-ic-resources"
            className="inline-block bg-[#A6410A] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-[#C25F0C] transition-colors duration-300"
          >
            All done? Back to Resources for Building an IC
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
